var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import { Guid } from '@ef-carbon/primitive';
import next from './next';
export class FormationWalker {
    constructor(_a) {
        var {cache, id} = _a, rest = __rest(_a, [
                'cache',
                'id'
            ]);
        this.formation = undefined;
        this.redirection = undefined;
        this.cache = cache;
        this.start = new Guid(id);
        this.options = Object.assign({}, rest);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.cache.configurable = false;
        descriptors.options.configurable = false;
        descriptors.start.writable = false;
        descriptors.start.configurable = false;
        descriptors.formation.enumerable = false;
        descriptors.formation.configurable = false;
        descriptors.redirection.enumerable = false;
        descriptors.redirection.configurable = false;
        Object.defineProperties(this, descriptors);
    }
    async next(context) {
        let [id, ctx] = Array.isArray(context) ? context : context ? [
            undefined,
            context
        ] : [
            undefined,
            {}
        ];
        if (id) {
            this.redirection = undefined;
            this.formation = await this.cache.fetch(new Guid(id));
        } else if (!this.formation) {
            this.formation = await this.cache.fetch(this.start);
        } else {
            ({
                formation: this.formation,
                context: ctx,
                redirect: this.redirection
            } = await next(this.cache, this.formation, this.redirection, ctx, this.options));
        }
        if (!this.formation) {
            throw new TypeError('Failed to retrieve next formation');
        }
        const {
            id: guid,
            discourse
        } = this.formation;
        return {
            done: false,
            value: {
                id: new Guid(guid),
                discourse,
                context: ctx
            }
        };
    }
    get id() {
        const formation = this.formation;
        const id = formation ? formation.id : this.start;
        return typeof id === 'string' ? new Guid(id) : id;
    }
    get discourse() {
        return this.formation ? this.formation.discourse : undefined;
    }
    get link() {
        return this.formation ? this.formation.link : undefined;
    }
    get redirect() {
        return this.redirection;
    }
    get tags() {
        return this.formation && this.formation.tags ? this.formation.tags : [];
    }
    get meta() {
        return this.formation && this.formation.meta ? this.formation.meta : {};
    }
    get features() {
        return new Set(this.meta.features || []);
    }
    async return() {
        this.cache.clear();
        if (this.formation) {
            const {
                id: guid,
                discourse
            } = this.formation;
            return {
                done: true,
                value: {
                    id: new Guid(guid),
                    discourse,
                    context: {}
                }
            };
        }
        return { done: true };
    }
    [Symbol.asyncIterator]() {
        return this;
    }
    async throw(error) {
        this.cache.clear();
        throw error;
    }
}
export {
    FormationWalker as Walker
};
export default FormationWalker;    //# sourceMappingURL=Walker.js.map
